// @flow
import React, { Component } from 'react'
import numeral from 'numeral'
import Tooltip from '../../components/Tooltip'
import styled, { type StyledComponent } from 'styled-components'
import _ from 'lodash'

const AdPopup: StyledComponent<Object, any, any> = styled.div`
  white-space: nowrap;
`

const AdPopupImage: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  width: 100px;
  height: 100px;
  background-size: cover;
  background-position: center;
  background-color: #eee;
  border-radius: 2px;
  font-size: 12px;
  text-align: center;
  padding: 45px 5px 0 5px;
`

const AdPopupTextInfo: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  width: 200px;
  padding: 0 10px;
  text-align: left;
  vertical-align: top;
  white-space: normal;
`

const AdPopupTitle: StyledComponent<Object, any, any> = styled.div`
  font-size: 16px;
  padding-bottom: 10px;
`

const AdPopupDescription: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
`

type Props = {
  value: Object,
  references: Object
}

type State = {
  popupVisible: boolean
}

export default class Value extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      popupVisible: false
    }
  }

  render() {
    const { value, references } = this.props

    if (value.type === 'advertisement_id') {
      return this.renderAdvertisement(
        value.value,
        references.advertisements[value.value.toString()]
      )
    }
    if (value.type === 'audience_id') {
      return this.renderAudience(value.value, references.audiences[value.value.toString()])
    }
    if (value.type === 'campaign_id') {
      return this.renderCampaign(value.value, references.campaigns[value.value.toString()])
    }

    return <span>{this.formattedValue(value)}</span>
  }

  renderAdvertisement(id: number, ad: Object) {
    return (
      <span>
        <span>{ad['name']} </span>
        {ad['archived'] ? (
          <span>#{id}</span>
        ) : (
          <Tooltip content={this.renderPopup(ad)} position="bottom-start">
            <a
              target="_blank"
              href={'/advertisements/' + id + '/edit'}
              onMouseEnter={() => this.showPopup()}
              onMouseLeave={() => this.hidePopup()}
            >
              #{id}
            </a>
          </Tooltip>
        )}
      </span>
    )
  }

  renderAudience(id: number, audience: Object) {
    return (
      <span>
        <span>{audience['name']} </span>
        {audience['archived'] ? (
          <span>#{id}</span>
        ) : (
          <a target="_blank" href={'/audiences/' + id + '/edit'}>
            #{id}
          </a>
        )}
      </span>
    )
  }

  renderCampaign(id: number, campaign: Object) {
    return (
      <span>
        {campaign['name']} #{id}
      </span>
    )
  }

  linkTo(path: string, id: number, entity: Object) {
    return (
      <span>
        <span>{entity['name']} </span>
        {entity['archived'] ? (
          <span>#{id}</span>
        ) : (
          <Tooltip content={this.renderPopup(entity)} position="bottom-start">
            <a target="_blank" href={path}>
              #{id}
            </a>
          </Tooltip>
        )}
      </span>
    )
  }

  showPopup() {
    this.setState({ popupVisible: true })
  }

  hidePopup() {
    this.setState({ popupVisible: false })
  }

  renderPopup(ad: Object) {
    return (
      <AdPopup>
        {ad['image'] ? (
          <AdPopupImage style={{ backgroundImage: 'url(' + ad['image'] + ')' }} />
        ) : (
          <AdPopupImage>No image</AdPopupImage>
        )}
        <AdPopupTextInfo>
          <AdPopupTitle>{ad['name']}</AdPopupTitle>
          <AdPopupDescription>{ad['description']}</AdPopupDescription>
        </AdPopupTextInfo>
      </AdPopup>
    )
  }

  formattedValue(value: Object) {
    if (value.type === 'precision-0') return numeral(value.value).format('0')
    if (value.type === 'precision-2') return numeral(value.value).format('0,0.00')
    if (value.type === 'percents-2') return numeral(value.value).format('0,0.00') + '%'
    if (_.includes(['regular', 'string'], value.type)) return value.value
    if (value.type === 'null') return '-'
    return 'unknown type!'
  }
}
